var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('HelperViewStatus',{staticClass:"order-error",attrs:{"data-testid":"order-error","generic-error":"","button-label":"Tentar novamente"},on:{"click":_vm.emitOnRetry}})
}
var staticRenderFns = []

export { render, staticRenderFns }